var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrowDropdown"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.34792 7.94284C5.56355 7.6733 5.95686 7.6296 6.2264 7.84523L10.0026 10.8662L13.7789 7.84523C14.0484 7.6296 14.4417 7.6733 14.6573 7.94284C14.873 8.21238 14.8293 8.60569 14.5597 8.82132L10.3931 12.1547C10.1648 12.3373 9.84046 12.3373 9.61219 12.1547L5.44553 8.82132C5.17599 8.60569 5.13229 8.21238 5.34792 7.94284Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDropdown);
export default __webpack_public_path__ + "static/media/arrowDropdown.3ca76adbfd6f9c1f2b7912cb48301077.svg";
export { ForwardRef as ReactComponent };